import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue";
const _hoisted_1 = { class: "customersTrelloFiltersContainer" };
const _hoisted_2 = { class: "filterContainer" };
const _hoisted_3 = { class: "filterBody" };
const _hoisted_4 = ["value"];
const _hoisted_5 = { class: "filterContainer" };
const _hoisted_6 = { class: "filterBody" };
const _hoisted_7 = ["value"];
const _hoisted_8 = { class: "filterContainer" };
const _hoisted_9 = { class: "filterBody" };
const _hoisted_10 = { class: "filterContainer" };
const _hoisted_11 = { class: "filterBody" };
const _hoisted_12 = { class: "filterContainer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "filterTitle" }, " Gestito da ", -1)),
            _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.vm.officeIdentifier) = $event))
                }, [
                    _cache[5] || (_cache[5] = _createElementVNode("option", { value: "" }, "Mostra tutti", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offices, (item, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                            value: item.identifier,
                            key: i
                        }, _toDisplayString(item.name), 9, _hoisted_4));
                    }), 128))
                ], 512), [
                    [_vModelSelect, _ctx.vm.officeIdentifier]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "filterTitle" }, " Assegnato a ", -1)),
            _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.vm.userIdentifier) = $event))
                }, [
                    _cache[7] || (_cache[7] = _createElementVNode("option", { value: "" }, "Mostra tutti", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (item, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                            value: item.identifier,
                            key: i
                        }, _toDisplayString(item.name), 9, _hoisted_7));
                    }), 128))
                ], 512), [
                    [_vModelSelect, _ctx.vm.userIdentifier]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_8, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "filterTitle" }, " Dal ", -1)),
            _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.vm.fromDate) = $event))
                }, null, 512), [
                    [_vModelText, _ctx.vm.fromDate]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_10, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "filterTitle" }, " Al ", -1)),
            _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.vm.toDate) = $event))
                }, null, 512), [
                    [_vModelText, _ctx.vm.toDate]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
                type: "button",
                class: "btn btn-green ml-2",
                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.$emit('apply', _ctx.vm)))
            }, "Applica")
        ])
    ]));
}
